import { useEffect } from "react";
import { scrollIntoView } from "../utils";
const useScrollIntoView = (scrollTo, elementId) => {
    useEffect(() => {
        if (scrollTo && scrollTo.id === elementId)
            scrollIntoView(scrollTo.id, scrollTo.offset);
    }, [scrollTo, elementId]);
};
export default useScrollIntoView;
//# sourceMappingURL=useScrollIntoView.js.map